"use client";

import { useRouter } from "next/navigation";

interface ErrorDisplayProps {
  message: string | null;
  nextRoute: string | null;
}

export default function ErrorDisplay({
  message,
  nextRoute,
}: ErrorDisplayProps) {
  const router = useRouter();

  const handleNext = () => {
    if (nextRoute) {
      router.push(nextRoute);
    } else {
      router.push("/"); // Default to homepage
    }
  };

  const buttonText = nextRoute ? "Continue" : "Go to Homepage";

  return (
    <div
      className="max-w-lg mx-auto bg-red-50 dark:bg-red-900/50 border border-red-200 dark:border-red-700 rounded-lg p-6"
      role="alert"
    >
      <div className="flex flex-col items-center">
        <svg
          className="h-8 w-8 text-red-700 dark:text-red-300"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="font-semibold text-lg text-red-700 dark:text-red-300 mt-2">
          {message || "We encountered an unexpected issue."}
        </span>
      </div>
      <div className="mt-6 flex justify-center">
        <button
          onClick={handleNext}
          className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
